module.exports = __webpack_public_path__ + "img/roma.d12cafc8.png";